/* ==========================================================================
   Chanel Serial Code Checker — Vintasje
   Toegevoegd door Elivado, 2026-08-24.

   Volledig client-side: geen backend, geen dependencies. De tool werkt per
   instantie (data-chanel-checker), dus de sectie mag meerdere keren op een
   pagina staan en her-initialiseert zichzelf in de theme editor.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     Referentietabel: serienummer-reeks -> geschatte productieperiode.
     Samengesteld uit publiek beschikbare Chanel-serienummerreferenties.
     Chanel heeft nooit een officiele tabel gepubliceerd en bronnen wijken
     per jaar licht af — behandel dit als een schatting, niet als een feit.
     ------------------------------------------------------------------------ */
  var SERIES_TABLE = {
    0: '1986–1988',
    1: '1989–1991',
    2: '1991–1994',
    3: '1994–1996',
    4: '1996–1997',
    5: '1997–1999',
    6: '2000–2002',
    7: '2002–2003',
    8: '2003–2004',
    9: '2004–2005',
    10: '2005–2006',
    11: '2006–2008',
    12: '2008–2009',
    13: '2009–2010',
    14: '2010–2011',
    15: '2011–2012',
    16: '2012',
    17: '2012–2013',
    18: '2013–2014',
    19: '2014',
    20: '2014',
    21: '2015–2016',
    22: '2016–2017',
    23: '2016–2017',
    24: '2017',
    25: '2017–2018',
    26: '2018–2019',
    27: '2018–2019',
    28: '2018–2019',
    29: '2019–2020',
    30: '2019–2020',
    31: '2021–2022'
  };

  function clean(raw) {
    return raw.toUpperCase().replace(/[\s\-\.]/g, '');
  }

  function init(root) {
    if (!root || root.dataset.ccReady === 'true') return;
    root.dataset.ccReady = 'true';

    var input = root.querySelector('[data-cc-input]');
    var button = root.querySelector('[data-cc-button]');
    var result = root.querySelector('[data-cc-result]');
    var label = root.querySelector('[data-cc-result-label]');
    var value = root.querySelector('[data-cc-result-value]');
    var text = root.querySelector('[data-cc-result-text]');

    if (!input || !button || !result || !label || !value || !text) return;

    function showResult(state, labelText, valueText, textHtml) {
      result.classList.add('is-visible');
      result.classList.toggle('is-error', state === 'error');
      label.textContent = labelText;
      value.textContent = valueText;
      text.innerHTML = textHtml;
    }

    function checkCode() {
      var code = clean(input.value);

      if (!code) {
        showResult(
          'error',
          'Enter a code',
          'No code entered',
          'Type your Chanel serial code into the field above and press Check.'
        );
        return;
      }

      /* 6-cijferige legacy codes: de vroegste 0-reeks werd soms zonder
         voorloopnul gedrukt. Aanvullen tot 7 cijfers en als 0-reeks lezen. */
      if (/^[0-9]{6}$/.test(code)) {
        code = '0' + code;
      }

      /* 7 cijfers -> reeks is het eerste cijfer (0-9) */
      if (/^[0-9]{7}$/.test(code)) {
        var series7 = parseInt(code.charAt(0), 10);
        var period7 = SERIES_TABLE[series7];
        if (period7) {
          showResult(
            'ok',
            'Estimated production period',
            period7,
            'Serial code <strong>' + code + '</strong> falls into series ' + series7 +
              ', used roughly between ' + period7 + '.'
          );
        } else {
          showResult(
            'unknown',
            'Format recognised, series unclear',
            'Series ' + series7,
            'We recognise this as a 7-digit code, but series ' + series7 +
              ' isn’t in our reference table. Double-check the digits and try again.'
          );
        }
        return;
      }

      /* 8 cijfers -> reeks is de eerste twee cijfers (10-31) */
      if (/^[0-9]{8}$/.test(code)) {
        var prefix8 = code.substring(0, 2);
        var series8 = parseInt(prefix8, 10);
        var period8 = SERIES_TABLE[series8];
        if (period8 && series8 >= 10) {
          showResult(
            'ok',
            'Estimated production period',
            period8,
            'Serial code <strong>' + code + '</strong> falls into series ' + series8 +
              ', used roughly between ' + period8 + '.'
          );
        } else {
          showResult(
            'unknown',
            'Format recognised, series unclear',
            'Series ' + prefix8,
            'This is an 8-digit code, but series ' + prefix8 +
              ' isn’t in our reference table yet. It may be a very recent series not yet catalogued.'
          );
        }
        return;
      }

      /* 7-8 tekens alfanumeriek -> metalen plaatje, vanaf 2021/2022 */
      if (/^[A-Z0-9]{7,8}$/.test(code) && /[A-Z]/.test(code) && /[0-9]/.test(code)) {
        showResult(
          'unknown',
          'Metal plate code',
          'From 2021/2022 onwards',
          'This looks like the newer alphanumeric metal-plate code Chanel introduced from around 2021–2022. ' +
            'These codes are unique per item but are not currently linked to a specific production year.'
        );
        return;
      }

      /* Alles daarbuiten: formaat niet herkend */
      showResult(
        'error',
        'Format not recognised',
        'Couldn’t decode this code',
        'This doesn’t match a known Chanel serial code format. Double-check the code on the sticker ' +
          'or authenticity card and try again.'
      );
    }

    button.addEventListener('click', checkCode);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        checkCode();
      }
    });
  }

  function initAll(scope) {
    var root = scope || document;
    if (root.matches && root.matches('[data-chanel-checker]')) init(root);
    Array.prototype.forEach.call(
      root.querySelectorAll('[data-chanel-checker]'),
      init
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* Theme editor: sectie opnieuw geladen -> opnieuw koppelen */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
